import { CurrencyBaseUnit } from '@shared/models/units/currency-units.model';

export const NO_CURRENCY = 'NONE';
export type NoCurrency = typeof NO_CURRENCY;
export type DisplayCurrency = CurrencyBaseUnit | NoCurrency;
